/**
 * @typedef {string} PaginationCursor
 * @typedef {string} Timestamp
 * @typedef {'collection'|'category'|'app'} DisplayType
 * @typedef {Object} SearchQuery
 *
 * @typedef {{
 *   name: string | SearchQuery
 * }} TaxonomyLinkFilter
 *
 * @typedef {{
 *   id: string,
 *   linkedTaxonomyId: string,
 *   name: string,
 *   description: string,
 *   dateCreated: Timestamp,
 *   dateModified: Timestamp,
 *   deliveryTimescale: {en-GB: string},
 *   handlingFee: number,
 *   image: string,
 *   images: string[],
 *   internalName: string,
 *   maxPrice: number,
 *   merchandisingSubtitle: string,
 *   merchandisingTitle: string,
 *   minPrice: number,
 *   over18: {1|0}
 *   redemptionInstructions: string,
 *   subtitle: string,
 *   tagIds: string[],
 *   taxonomyIds: string[],
 *   vat: number
 *   vatAudience: {"B2B"|"B2C"}
 *   vatIssuer: {"huggg"|"supplier"}
 *   vatVoucherType: {"SPV"|"MPV"}
 * }} TaxonomyLinkItem
 *
 * @typedef {{
 *   data: TaxonomyLinkItem[],
 *   hasNext: boolean,
 *   hasPrevious: boolean,
 *   next: PaginationCursor,
 *   previous: PaginationCursor
 * }} TaxonomyLinksSearchResponse
 */

import v3Generic from './v3-generic';
var _v3Generic = v3Generic('taxonomy-links'),
  search = _v3Generic.search,
  single = _v3Generic.single;
export default {
  /**
   *
   * @param {Object} [optional] $axios
   * @param {import('./v3-generic').MongoSearchOptions} options
   *
   * @returns {Promise<TaxonomyLinksSearchResponse>} Unresolved Promise from the API.
   */
  search: search,
  /**
   * Fetch a singular taxonomy by ID
   *
   * @param {Object} [optional] $axios Axios instance.
   * @param {String} id
   *
   * @returns {Promise<TaxonomyLinkItem>} Unresolved Promise from the API.
   */
  single: single
};